import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuex from 'vuex'
import store from './store/store'
import VueMq from 'vue-mq'

// VueMq: Responsive stuff
Vue.use(VueMq, {
	breakpoints: {
		sm: 601,
		md: 1001,
		lg: Infinity
	},
	defaultBreakpoint: 'sm'
})

// Vuex: persistent storage
Vue.use(Vuex)

// Click Outside directive; closing popups etc.
Vue.directive('click-outside', {
	bind: function (el, binding, vnode) {
		el.clickOutsideEvent = function (event) {
			// here I check that click was outside the el and his childrens
			if (!(el === event.target || el.contains(event.target))) {
				// and if it did, call method provided in attribute value
				vnode.context[binding.expression](event)
			}
		}
		document.body.addEventListener('click', el.clickOutsideEvent)
	},
	unbind: function (el) {
		document.body.removeEventListener('click', el.clickOutsideEvent)
	}
})

Vue.config.productionTip = false

// Vue router
new Vue({
	router,
	store,
	render: function (h) { return h(App) }
}).$mount('#app')
